/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PriceExplainModifierItemApiModel } from './price-explain-modifier-item';
import { PriceExplainValueTypeApiModel } from './price-explain-value-type';
import { PriceExplainValueSourceApiModel } from './price-explain-value-source';

export interface PriceExplainLevelItemApiModel {
  /**
   * Master price selection date and type (optional)
   */
  datetime?: string | null;
  /**
   * Number of decimal digits in value
   */
  decimal_digits?: number | null;
  /**
   * Initial value of current price level
   */
  initial_value?: number | null;
  /**
   * Level number (optional, for first level items only)
   */
  level?: number | null;
  /**
   * Level type (optional, for first level items only)
   */
  level_type?: PriceExplainLevelItemApiModelLevelTypeEnum;
  modifier?: PriceExplainModifierItemApiModel;
  source?: PriceExplainValueSourceApiModel;
  type?: PriceExplainValueTypeApiModel;
  /**
   * Result value of current price level
   */
  value?: number | null;
  /**
   * Value Id if exists (optional)
   */
  value_id?: string;
  /**
   * Value title if exists (optional)
   */
  value_title?: string;
}
export enum PriceExplainLevelItemApiModelLevelTypeEnum {
  PriceBase = 'price-base',
  PriceIncludingTaxes = 'price-including-taxes',
  PricePosted = 'price-posted',
  PriceSale = 'price-sale',
  PriceCorporateCustomer = 'price-corporate-customer',
  PriceRetailCustomer = 'price-retail-customer'
}
